import { useQueryClient, useQuery, useMutation } from '@tanstack/react-query';
import { notification, Row, Col, Button, Input, Form, Select, Modal, Divider} from 'antd';
import React, { useState } from 'react'
import { useParams } from 'react-router-dom';
import Loader from '../../../components/loader';
import { getArticle, getArticlesConnectedPhotos, getLanguages, postArticleUpdate } from '../../../services/api';
import { Editor } from '@tinymce/tinymce-react';
import PageTitle from '../../../components/page-title';
import { PhotosWrap } from '../../../styles/global';
import Photo from '../../../components/photo';
import { SearchOutlined } from '@ant-design/icons';
import ModalPhotoSearch from '../../../components/modal-photo-search';

const BlogsEdit = () => {
    
    const { id } = useParams();
    const queryClient = useQueryClient();
    const [ ntf, contextHolder ] = notification.useNotification();
    const { data, isLoading, isFetched: isFetchedData } = useQuery(['blog', id], () => getArticle(id), {enabled: !!id, cacheTime: 0, staleTime: 0});
    const { data: dataConnectedPhotos, isLoading: isLoadingConnectedPhotos, isFetched: isFetchedConnectedPhotos } = useQuery(['photos-blog', id], () => getArticlesConnectedPhotos(id), {enabled: !!id});
    const { data: dataLanguages, isLoading: isLoadingLanguages } = useQuery(['languages'], () => getLanguages(), {enabled: !!id});
    const { mutate: mutatePostArticleUpdate } = useMutation(postArticleUpdate);

    const [editorValue, setEditorValue] = useState("");
    const [isModalSearchOpen, setIsModalSearchOpen] = useState(false);

    const editorInitConfig = {
        height: 300,
        forced_root_block: '',
        plugins: [
            'paste',
            'lists'
        ],
        menubar: 'edit',
        toolbar: 'undo redo | bold italic underline strikethrough | paste pastetext | bullist numlist | removeformat',
        content_style: 'body { font-family: Helvetica,Arial,sans-serif; font-size:16px }'
    }

    const handleSubmit = (values: any) => {
        mutatePostArticleUpdate({id: id, text: editorValue, title: values.title, text_main: values.text_main, tzpe: 1, language_id: values.language_id }, {
            onSuccess() {
                queryClient.invalidateQueries(['blogs', 'blog'+id, 'placeholders']);
                ntf.success({
                    message: `Success`,
                    description: "Updated with success!",
                    placement: "bottomLeft",
                });
            },
            onError() {
                ntf.error({
                    message: `Error`,
                    description: "Something gonne wrong!",
                    placement: "bottomLeft",
                });
            },
        })
    }

    if (isLoading && isLoadingLanguages) {
        return (
            <Row justify="center">
                <Col span={20}>
                    <Row justify="center"><Loader size={50} /></Row>
                </Col>
            </Row>
        )
    }

    const mapLanguages = () => {
        let langs: any = [];
        dataLanguages && dataLanguages.map((lang: any) => {
            langs.push({value: lang.id, label: lang.name})
        })
        return langs;
    }

    if (!isFetchedData) {
        return <></>
    }
    
    return (
        <Row justify="center">
            {contextHolder}
            <PageTitle text={`Article: ${isFetchedData && data.title}`} />
            <Col span={20}>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form
                            name="blog_update"
                            style={{ width: "100%"}}
                            layout="vertical"
                            onFinish={handleSubmit}
                        >
                            <Form.Item
                                label="Blog title goes here"
                                name="title"
                                initialValue={isFetchedData && data.title}
                            > 
                                <Input placeholder='Kuda idu divlje svinje' />
                            </Form.Item>
                            <Form.Item
                                label="Here you can add short text for the pages where the article short description is showed. Maybe put one sentence."
                                name="text_main"
                                initialValue={isFetchedData && data.text_main}
                            > 
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="You must assign a language to this placeholder. Otherwise it will not be displayed on the website."
                                name="language_id"
                                initialValue={isFetchedData && data.language_id}
                            > 
                                <Select
                                    placeholder="Select language of placeholder"
                                    allowClear
                                    defaultValue={isFetchedData && data.language_id}
                                    options={mapLanguages()}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Content value (can be url, html, plain text)"
                            >   
                                <Editor
                                    apiKey='l1bfxq2606zcs9deej0javlspqpdff9g2nlf21ik18hdmdmm'
                                    onInit={() => {
                                        setEditorValue(isFetchedData && data.text)
                                    }}
                                    onChange={(content: any) => setEditorValue(content.level.content)}
                                    initialValue={isFetchedData && data.text}
                                    init={editorInitConfig}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" className="login-form-button">Save</Button>
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col span={24}>
                        <Divider>Photo Gallery for this Blog</Divider>
                        <Button type="primary" icon={<SearchOutlined />} onClick={() => setIsModalSearchOpen(true)}>Photo Store search</Button>
                        <Modal
                            title="Search Photo Store"
                            open={isModalSearchOpen}
                            onCancel={() => setIsModalSearchOpen(false)}
                            width={900}
                            footer={false}
                        >
                            <ModalPhotoSearch isOpen={isModalSearchOpen} contentId={id} />
                        </Modal>
                        <Divider>Connected photos ({isFetchedConnectedPhotos && dataConnectedPhotos.length})</Divider>
                        <PhotosWrap>
                            {isFetchedConnectedPhotos && dataConnectedPhotos.map((photo: any) => {
                                return <Photo alt={photo.description} src={photo.name} photoId={photo.id} contentId={id} main={photo.main} />
                            })}
                        </PhotosWrap>
                        <Divider></Divider>
                    </Col>
                </Row>
            </Col>
        </Row>
      )
}

export default BlogsEdit